var _path, _path2, _rect, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrangeConstraints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39324 9.12516H2.0293V1.875H9.27945V9.12516H6.89771",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5548 5.78109L12.9045 5.78109L12.9045 8.3125M7.99344 5.78109L5.65438 5.78109L5.65438 13.0312L8.90625 13.0312",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3535,
    y: 11.955,
    width: 0.957606,
    height: 0.957606,
    fill: "#00C2FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.7899,
    y1: 12.4126,
    x2: 15.9998,
    y2: 12.4126,
    stroke: "#00C2FF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.67505,
    y1: 12.4807,
    x2: 11.8849,
    y2: 12.4807,
    stroke: "#00C2FF"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8533,
    y1: 13.4512,
    x2: 12.8533,
    y2: 15.661,
    stroke: "#00C2FF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.8533,
    y1: 9.12518,
    x2: 12.8533,
    y2: 11.335,
    stroke: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeConstraints);
export default __webpack_public_path__ + "static/media/arrange-constraints.8df28be00602f979114df77db3ed54fb.svg";
export { ForwardRef as ReactComponent };